export const DEBUG_OPTION_MODE = 'Mode';
export const DEBUG_VALUE_MODE_PREVIEW = 'Preview';
export const DEBUG_VALUE_MODE_PUBLISHED = 'Published';

export const DEBUG_OPTION_LANGUAGE = 'Language';
export const DEBUG_VALUE_LANGUAGE_ENGLISH = 'en';
export const DEBUG_VALUE_LANGUAGE_POLISH = 'pl';

export const DEBUG_OPTION_GRID = 'Grid';
export const DEBUG_VALUE_GRID_OFF = 'OFF';
export const DEBUG_VALUE_GRID_ON = 'ON';

export const DEBUG_CONFIG_SESSION_STORAGE_KEY = 'zonifero_debug_config';



// WEBPACK FOOTER //
// ./src/common/consts/debugOptionConsts.js